import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { Gradient } from 'utils/types';

import { Box, Stack } from '@mui/material';

export const StyledProductMadnessSpecialOffer = styled.div<{
  backgroundSrc: string;
  backgroundColor: Gradient;
}>`
  max-width: 400px;
  min-width: 235px;
  width: 100%;
  --secondary-text-color: #f89fbc;
  font-family: Lato;
  background: ${({ backgroundSrc, backgroundColor }) =>
    backgroundSrc
      ? `url("${backgroundSrc}")`
      : createGradientOrSolid(backgroundColor)};
  background-size: 100% 100%;
  height: 200px;
  display: flex;
  z-index: 1;
  flex-direction: column;
  position: relative;
  padding: 2px 7px 2px 2px;
  border-radius: 7px;
  box-sizing: border-box;
`;

export const StyledPriceSection = styled(Box)`
  display: flex;
  color: #ffff;
  flex-direction: column;
  font-family: Lato;
  align-items: center;

  .availability,
  .timer {
    font-size: 12px;
    font-weight: 500;
  }
`;

export const StyledSubItems = styled(Box)`
  margin-top: auto;
  margin-bottom: 9px;
  display: flex;
  align-items: center;

  .prefix-text {
    color: #ffff;
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
  }

  .grid {
    display: flex;
    overflow: hidden;
    max-height: 20px;

    > div {
      display: flex;
      white-space: nowrap;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0;
    }
  }
`;

export const StyledScrollerButton = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  border: 0;
  position: relative;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;

  &:hover {
    cursor: pointer;
  }
`;
